import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "../Shared/Components/CustomDialog";
import PropTypes from "prop-types";
import { Button, TextField, Typography } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  MenuItemOption: {
    "@media (hover: none) , (pointer: coarse)": {
      "&:focus": {
        backgroundColor: "#fff",
      },
    },
  },
  select: {
    backgroundColor: "#fff",
    minWidth: 200,
    [theme.breakpoints.down("xs")]: {
      minWidth: 160,
    },
  },
  dialogContentRoot: {
    paddingBottom: 20,
    "& > label": { padding: "20px 0" },
  },
  toolTitle: {
    alignSelf: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  dialogRoot: {
    "& .MuiBackdrop-root": {
      opacity: "0 !important",
    },
    "& .MuiPaper-root > div": {
      backgroundColor: "#e8e9eb",
    },
  },
  root: {
    display: "flex",
    margin: "30px 0 0",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  label: {
    fontWeight: "bold",
    textAlign: "left",
    verticalAlign: "middle",
    wordBreak: "break-word",
    whiteSpace: "normal",
    width: "30%",
    display: "flex",
    alignItems: "center",
  },
  dropdown: {
    display: "inline-flex",
    width: "60%",
    minWidth: 160,
    marginLeft: 20,
    float: "right",
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
    },
  },
}));

const LayerOptionsDialog = (props) => {
  const { show, dialogPosition, onClose, floor, updateFloor } = props;
  const { t } = useTranslation(["layerOptionsDialog", "common"]);
  const { artusComponentOptions } = useSelector((state) => {
    return state.Configuration;
  });
  const classes = useStyles();
  const data = [
    {
      key: "floor",
      title: t("common:floor"),
      selected: floor,
      function: (e) => {
        updateFloor(e.target.value);
      },
      options: artusComponentOptions.find((opt) => opt.key === "floor").options,
    },
  ];
  return (
    <CustomDialog
      open={show}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      dialogTitle={t("layerOptions")}
      onCancel={onClose}
      maxWidth="xs"
      className={classes.dialogRoot}
      // PaperProps={{
      //   style: {
      //     left: dialogPosition.left - 220,
      //     bottom: dialogPosition.bottom + 30,
      //     position: "fixed",
      //     margin: 8,
      //   },
      // }}
    >
      <DialogContent className={classes.dialogContentRoot}>
        {data.map((item, i) => (
          <div className={classes.root}>
            <Typography className={classes.label} variant={"body2"}>
              {item.title}{" "}
            </Typography>
            <div className={classes.dropdown}>
              <Select
                classes={{ root: classes.select }}
                variant="outlined"
                value={item.selected}
                onChange={item.function}
              >
                {item.options &&
                  item.options.map((option, i) => (
                    <MenuItem
                      className={classes.MenuItemOption}
                      key={option.title + i}
                      value={option.identifier}
                    >
                      <Typography className={classes.toolTitle} noWrap>
                        {option.title}
                      </Typography>
                    </MenuItem>
                  ))}
              </Select>
            </div>
          </div>
        ))}
      </DialogContent>
    </CustomDialog>
  );
};

LayerOptionsDialog.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
};

export default LayerOptionsDialog;
